import { Link } from 'react-router'
import { Reveal, Section, SectionHeading } from '@/components/primitives'

const MODULES = [
  {
    id: '01',
    name: 'One customer story',
    line: 'Every touch lands on the same record. No swivel-chair.',
    to: '/platform',
  },
  {
    id: '02',
    name: 'Rules that run',
    line: 'Routing, queues, and workflows follow your rules, versioned and accountable.',
    to: '/platform',
  },
  {
    id: '03',
    name: 'Communications on the record',
    line: 'Calls, texts, and notes stay attached to the person, not lost in another app.',
    to: '/platform',
  },
  {
    id: '04',
    name: 'The floor, live',
    line: 'See who’s working what, what’s stuck, and what happens next.',
    to: '/platform',
  },
  {
    id: '05',
    name: 'Nex',
    line: 'Ask the system. Draft the change. Keep control.',
    to: '/nex',
  },
]

export function FiveModules() {
  return (
    <Section labelledBy="modules-heading">
      <Reveal>
        <SectionHeading
          id="modules-heading"
          title="Five things operators remember after the walkthrough."
          copy="The platform is deep. The story is simple. This is what sticks."
        />
      </Reveal>

      <Reveal delay={80}>
        <ol className="mt-12 grid gap-px overflow-hidden rounded-sm border border-base-line bg-base-line sm:grid-cols-2 lg:grid-cols-5">
          {MODULES.map((mod) => (
            <li key={mod.id} className="flex flex-col bg-base-850 p-5 text-center">
              <span className="font-mono text-[11px] font-medium uppercase tracking-[0.16em] text-signal">
                {mod.id}
              </span>
              <p className="mt-3 text-base font-extrabold tracking-tight text-ink">{mod.name}</p>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-ink-mute">{mod.line}</p>
              <Link
                to={mod.to}
                className="mt-5 font-mono text-[11px] font-medium uppercase tracking-[0.14em] text-ink-dim transition-colors duration-state hover:text-signal"
              >
                See it →
              </Link>
            </li>
          ))}
        </ol>
      </Reveal>

      <Reveal delay={120}>
        <p className="mx-auto mt-8 max-w-2xl text-center text-sm font-semibold text-ink">
          CRMs store contacts. Dialers make noise.{' '}
          <span className="text-signal">TLDNXS runs the work.</span>
        </p>
      </Reveal>
    </Section>
  )
}
